import React from "react";
import LicenseLimitedModal from "@/components/modal/license-limited-modals/license-limited-modal";
import { LicenseName } from "@/data/license.data";

type TextToMusicLimitedModalProps = {
  licenseName: LicenseName;
};

const TextToMusicLimitedDurationModal = ({
  licenseName,
}: TextToMusicLimitedModalProps) => {
  return (
    <LicenseLimitedModal
      licenseName={licenseName}
      upgradeToMessage={"generate up to 1 minute duration music from text"}
      allowsMessage={`${licenseName} version is limited in duration to a maximum of 15 seconds.`}
      shouldNavigateToPricing={false}
    />
  );
};

export default TextToMusicLimitedDurationModal;
